import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Who Can Leverage Our Telemedicine App Development Services?</h2>
            <p>
              We can provide our clients with a completely customized
              telemedicine app that serves the purpose of boosting their
              healthcare capabilities with digital means and tools. Whether you
              are a virtual healthcare service provider, a health professional,
              or a medical facility, we are proficient at customizing solutions
              in such a way that they fit the needs of specific clients.
            </p>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>Telemedicine Service Providers</h4>
                <p>
                  Our app development service empowers remote communities to
                  join telemedicine, modernizing their healthcare services and
                  staying competitive.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>
                  Healthcare
                  <br /> Professionals
                </h4>
                <p>
                  Our telemedicine apps help doctors access patient records,
                  manage bookings, and conduct online consultations, improving
                  healthcare delivery for all.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box">
              <div className="perks-content">
                <h4> Medical Centers and Hospitals</h4>
                <p>
                  Medical centers and hospitals can benefit from our
                  telemedicine services through improved patient care, workflow
                  efficiency, and seamless integration of telehealth solutions
                  into existing systems.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box">
              <div className="perks-content">
                <h4>Customized Telehealth Solutions</h4>
                <p>
                  Our custom app development services for separate cases
                  requiring niche telehealth solutions are tailored to address
                  specific needs.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
